import React from 'react';
import { IUpsellRule } from '../../interfaces';
import ProductPriceFormat from '../../../../projects/products/product-price/product-price-format';

interface IMilestoneText {
    isChecked: boolean;
    pluginsCount: number;
    upsellRule: IUpsellRule;
    isLast: boolean;
}

const MilestoneText = ({ isChecked, pluginsCount, upsellRule, isLast }: IMilestoneText) => {
    return (
        <div
            className={ `flex absolute flex-col ${ isLast ? 'text-right' : 'text-center ' }` }
            style={{
                width: 'fit-content',
                marginTop: isChecked ? '59px' : '57px',
                marginRight: isLast ? '20px' : '1px',
                color: isChecked ? '#111' : 'rgb(89, 92, 95)',
                fontSize: '11px',
            }}>
            <span style={{
                whiteSpace: 'nowrap',
                fontWeight: isChecked ? 'bold' : 'normal',
            }}>{ pluginsCount } plugin{ pluginsCount === 1 ? '' : 's' }</span>
            <span className={ isChecked ? 'font-bold' : 'font-normal' }>
                <ProductPriceFormat price={ upsellRule.value } />
            </span>
        </div>
    )
};

export default MilestoneText;